import { render } from "./ModalOverlay.vue?vue&type=template&id=6e7c6e1f"
import script from "./ModalOverlay.vue?vue&type=script&lang=js"
export * from "./ModalOverlay.vue?vue&type=script&lang=js"

import exportComponent from "/data/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__